// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-with-cubo{display:flex}.logo-with-cubo>.cubo-logo{font-size:var(--step-4);padding-right:8px;color:#fff;line-height:1.5}.logo-with-cubo>.influx-cloud-logo{width:150px;height:50px;display:flex}", ""]);
// Exports
module.exports = exports;
